module.exports = __webpack_public_path__ + "img/ic_referafriend_disabled.613a439f.svg";